import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Name from './Order/Name';
import Terms from './Order/Terms';
import Type from './Order/Type';
import CommisionAndContracts from './Order/CommisionAncContracts';
import CargoBlock from './Order/CargoBlock';
import TotalValuesVolWei from './Order/TotalValuesVolWei';
import AccountName from './Order/AccountName';
import Title from '../../../../common/RequestTitle';
import { VesselRequirements } from './Order/VesselRequirements';
import { updateCargoOrder } from 'actions/cargoes/orders';

class OrderTable extends React.PureComponent {
    update = (data) => {
        this.props.updateCargoOrder(this.props.numberOrderTable, {
            ...this.props.cargoOrder,
            ...data,
        });
    }

    render() {
        return (
            <div className='sidebar-table'>
                <Title 
                    orderNumber={this.props.numberOrderTable + 1} 
                    text='CARGO REQUEST NUMBER'
                    warnings={this.props.cargoOrder.warnings} 
                />
                <Name numberOrderTable={this.props.numberOrderTable} />
                <Type numberOrderTable={this.props.numberOrderTable} />
                <TotalValuesVolWei numberOrderTable={this.props.numberOrderTable} />
                <AccountName numberOrderTable={this.props.numberOrderTable} />
                <CargoBlock numberOrderTable={this.props.numberOrderTable} />
                <CommisionAndContracts numberOrderTable={this.props.numberOrderTable} />
                <VesselRequirements
                    captureSaveHandler={(fn) => {
                        this.props.captureSaveHandler((cargoOrder) => {
                            fn(cargoOrder.vesselRequirements);
                        });
                    }}
                    initialState={this.props.cargoOrder.vesselRequirements}
                    onChange={this.update}
                />
                <hr />
                <Terms numberOrderTable={this.props.numberOrderTable} />
                <hr />
            </div>
        );
    }
}

export default connect(
    (state, ownProps) => {
        const cargoOrder = state.cargoOrders.items[ownProps.numberOrderTable];
        return {
            numberOrderTable: ownProps.numberOrderTable,
            cargoOrder,
        };
    },
    dispatch => bindActionCreators({
        updateCargoOrder,
    }, dispatch),
)(OrderTable);



// WEBPACK FOOTER //
// ./app/components/Letters/SingleNew/Cargo/Sidebar/OrderTable.jsx